export default __webpack_public_path__ + "static/media/09_gallery.fe582aec.jpg";